import styled from 'styled-components'

import { colors } from '../../../../../shared/styles/colors'

export const Title = styled.div`
  color: 'rgba(62, 62, 62, 1)';
  font-weight: 700;
  font-size: 18px;
  padding-bottom: 16;
  padding-left: 24px;
  padding-top: 20px;
`
export const IconMessage = styled.div`
  padding-left: 24px;
  padding-top: 21px;
  padding-bottom: 10px;
`

export const TextRequisito = styled.div`
  height: 60px;
  padding-left: 10px;
  align-content: 'center';
  align-items: 'center';
  width: '100%';
  padding-top: 20px;
  padding-bottom: 10px;
`
export const Paragraph = styled.div`
  color: rgba(109, 120, 125, 1);
  margin-right: 150px;
  padding-bottom: 20px;
  padding-left: 24px;
`

export const ErrorMessage = styled.div`
  font-size: 12px;
  color: ${colors.red2};
  margin-top: -20px;
  padding-left: 10px;
  padding-bottom: 10px;
`
export const WarningMessage = styled.div`
  font-size: 12px;
  color: ${colors.yellow};
  margin-top: -20px;
  padding-left: 10px;
  padding-bottom: 10px;
`
export const CloseButton = styled.div`
  color: ${colors.primary};
  font-weight: 700;
  font-size: 18px;
  padding-bottom: 16px;
  padding-left: 24px;
  padding-top: 20px;
  cursor: pointer;
`
export const Requisitos = styled.div`
  color: '#000000D9';
  background-color: ${colors.neutral};
  font-weight: 700;
  font-size: 18px;
  height: 50px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 24px;
`

export const ArrowButton = styled.div`
  padding-top: 15px;
  cursor: pointer;
`
